import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getToken } from '../context/AuthContext';
import config from '../config';

const VISITOR_KEY = 'vs_visitor_id';

// Anonymous, per-browser ID so the admin dashboard can count unique visitors.
function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id && window.crypto?.randomUUID) {
      id = window.crypto.randomUUID();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id || null;
  } catch {
    return null;
  }
}

// Reports each SPA route change to the backend for the admin usage dashboard.
export default function PageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    const token = getToken();
    fetch(`${config.apiBaseURL}/api/events/pageview`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ path: pathname, visitorId: getVisitorId() }),
    }).catch(() => {});
  }, [pathname]);

  return null;
}
